import BaseEnumType from "../../common/base-enum-type";

const MatchTiebreakType = Object.freeze({
    None: new BaseEnumType("1", "None"),
    Sets: new BaseEnumType("2", "Sets"),
    Points: new BaseEnumType("3", "Points")
});

export const Options = Object.keys(MatchTiebreakType).map(
    (key) => MatchTiebreakType[key]
);

export default MatchTiebreakType;
